import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { http, errMsg, money, inputCls, labelCls } from "../lib/market";
import { Eyebrow, GlassCard } from "../components/Section";

const Report = ({ pid }) => {
  const [r, setR] = useState(null);
  useEffect(() => { http.get(`/justice-wallet/programmes/${pid}/report`).then(({ data }) => setR(data)).catch((e) => toast.error(errMsg(e))); }, [pid]);
  if (!r) return null;
  return (
    <div className="mt-4 border-t border-white/8 pt-4 font-inter text-sm space-y-2" data-testid={`donor-report-${pid}`}>
      <div className="grid sm:grid-cols-5 gap-3">{Object.entries(r.budget).map(([k, v]) => <div key={k}><div className="text-white/40 text-[11px]">{k.replace(/_minor/, "").replace(/_/g, " ")}</div>{money(v)}</div>)}</div>
      <div className="text-white/65">Beneficiaries supported: <b data-testid={`donor-beneficiaries-${pid}`}>{r.beneficiaries_supported}</b> · Services completed: <b>{r.services_completed}</b></div>
      <div className="text-white/50 text-xs">By category: {Object.entries(r.allocations_by_category).map(([k, v]) => `${k} (${v})`).join(", ") || "—"}</div>
      <p className="text-[11px] text-white/35">{r.privacy_note}</p>
    </div>
  );
};

export default function DonorPortal() {
  const [progs, setProgs] = useState([]);
  const [open, setOpen] = useState(null);
  const [amount, setAmount] = useState({});
  const load = useCallback(() => http.get("/donor/programmes").then(({ data }) => setProgs(data.programmes)).catch((e) => toast.error(errMsg(e))), []);
  useEffect(() => { load(); }, [load]);
  const fund = async (pid) => {
    try { await http.post(`/justice-wallet/programmes/${pid}/fund`, { amount: Number(amount[pid]) }); toast.success("Restricted funding recorded (sandbox)"); setAmount({ ...amount, [pid]: "" }); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <main className="bg-ink text-white min-h-screen py-12" data-testid="donor-portal-page">
      <div className="container mx-auto px-5 sm:px-8 max-w-5xl">
        <Eyebrow>Sponsor & Donor Portal</Eyebrow>
        <h1 className="font-playfair text-4xl sm:text-5xl mt-3 mb-3">Your <span className="italic text-aj-gradient">impact.</span></h1>
        <p className="font-inter text-sm text-white/50 mb-10 max-w-2xl">Funds remain restricted to the legal-service categories you approved and are never used for platform operating costs. Reports are aggregated — no beneficiary identities or privileged documents.</p>
        <div className="space-y-5">
          {progs.length === 0 && <GlassCard data-testid="donor-empty">No programmes yet.</GlassCard>}
          {progs.map((p) => (
            <GlassCard key={p.programme_id} data-testid={`donor-programme-${p.programme_id}`}>
              <div className="flex flex-wrap items-start gap-4">
                <div className="flex-1"><div className="font-playfair text-2xl">{p.name}</div><div className="font-inter text-xs text-white/45 mt-1">{p.approved_category_ids.join(" · ")}</div></div>
                <div className="text-right"><div className={labelCls}>Available</div><div className="font-playfair text-3xl text-gold-200" data-testid={`donor-available-${p.programme_id}`}>{money(p.available_minor)}</div></div>
              </div>
              <p className="font-inter text-xs text-white/40 mt-3">{p.restrictions}</p>
              <div className="flex flex-wrap gap-3 mt-5">
                <input className={`${inputCls} !w-48`} type="number" placeholder="Add funds ₦" value={amount[p.programme_id] || ""} onChange={(e) => setAmount({ ...amount, [p.programme_id]: e.target.value })} data-testid={`donor-fund-input-${p.programme_id}`} />
                <button className="btn-aj-primary" disabled={!amount[p.programme_id]} onClick={() => fund(p.programme_id)} data-testid={`donor-fund-btn-${p.programme_id}`}>Add restricted funds</button>
                <button className="btn-aj-ghost" onClick={() => setOpen(open === p.programme_id ? null : p.programme_id)} data-testid={`donor-report-btn-${p.programme_id}`}>{open === p.programme_id ? "Hide" : "View"} impact report</button>
              </div>
              {open === p.programme_id && <Report pid={p.programme_id} />}
            </GlassCard>))}
        </div>
      </div>
    </main>
  );
}
